/**
 * Helper function to get the key for the first column in a table.
 * If 'name' exists and has a value, returns 'name'.
 * Otherwise, if 'currency' exists, returns 'currency'.
 * Returns null if neither key is present.
 *
 * @param {Array<Object>} balances - Array of balance objects
 * @returns {string|null} - The key to use for the first column, or null if not found
 */
export const getFirstColumnKey = (balances: Array<Record<string, unknown>> | null | undefined): string | null => {
  if (!balances?.length) return null;

  const firstItem = balances[0];

  if (firstItem.name) return 'name';
  return 'currency';
};
